import { type Opportunity } from "@repo/api";
import { assertUnreachable } from "@repo/utils";
import { type ActionType, createAction, getType } from "typesafe-actions";

type ProjectDetailsModalStep = "DETAILS" | "CUSTOMER_MEETING_POINT";

export interface ReducerState {
  currentStep: ProjectDetailsModalStep;
  title?: Opportunity["title"];
  cmp?: Opportunity["customerMeetingPointBuCode"];
  hfb?: Opportunity["hfb"];
  owner?: Opportunity["owner"];
  assignedTeam?: Opportunity["assignedTeam"];
  tags?: Opportunity["tags"];
  updateLoading: boolean;
}

export const ReducerStateDefault: ReducerState = {
  currentStep: "DETAILS",
  title: undefined,
  cmp: undefined,
  hfb: undefined,
  owner: undefined,
  assignedTeam: undefined,
  updateLoading: false,
  tags: undefined,
};

export type ReducerStateActions = typeof reducerStateActions;

export const reducerStateActions = {
  setStep: createAction("SET_STEP")<ProjectDetailsModalStep>(),
  setTitle: createAction("SET_TITLE")<ReducerState["title"]>(),
  setCmp: createAction("SET_CMP")<ReducerState["cmp"]>(),
  setHfb: createAction("SET_HFB")<ReducerState["hfb"]>(),
  setTags: createAction("SET_TAGS")<ReducerState["tags"]>(),
  setAssignedTeam:
    createAction("SET_ASSIGNED_TEAM")<ReducerState["assignedTeam"]>(),
  setLoading: createAction("SET_LOADING")<ReducerState["updateLoading"]>(),
};

export function modalReducerStateReducer(
  state: ReducerState,
  action: ActionType<ReducerStateActions>
): ReducerState {
  switch (action.type) {
    case getType(reducerStateActions.setStep):
      return {
        ...state,
        currentStep: action.payload,
      };
    case getType(reducerStateActions.setTitle):
      return {
        ...state,
        title: action.payload,
      };
    case getType(reducerStateActions.setCmp):
      return {
        ...state,
        cmp: action.payload,
      };
    case getType(reducerStateActions.setHfb):
      return {
        ...state,
        hfb: action.payload,
      };
    case getType(reducerStateActions.setAssignedTeam):
      return {
        ...state,
        owner: undefined,
        assignedTeam: action.payload,
      };
    case getType(reducerStateActions.setLoading):
      return {
        ...state,
        updateLoading: action.payload,
      };
    case getType(reducerStateActions.setTags):
      return {
        ...state,
        tags: action.payload,
      };
  }
  assertUnreachable(action);
}
